import { defineStore } from 'pinia'
import { computed, ref } from 'vue'

export type FeatureFlagKeys = 'dev-mode' | 'connect-variant' | FlagDesign

const DESIGN_VARIANTS = ['design-v1', 'design-v2'] as const
type FlagDesign = (typeof DESIGN_VARIANTS)[number]

export type FeatureFlags = Map<FeatureFlagKeys, boolean>

export const useFeatureFlagStore = defineStore('feature-flag', () => {
  const flags = ref<FeatureFlags>(new Map<FeatureFlagKeys, boolean>())

  flags.value.set('dev-mode', import.meta.env.VITE_ENV_VAR === 'DEVELOPMENT')

  const flagDesign = computed(() => {
    return DESIGN_VARIANTS.find((it) => flags.value.get(it) === true)
  })

  function enableDesign(flag: FlagDesign) {
    DESIGN_VARIANTS.forEach((design) => {
      flags.value.set(design, false)
    })
    flags.value.set(flag, true)
  }

  return { flags, flagDesign, enableDesign }
})
